import React, { useState, useEffect, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getOrder } from '../services/api';

function formatRupiah(n) { return 'Rp ' + n.toLocaleString('id-ID'); }

const statusMap = {
  pending:    { emoji: '⏳', label: 'Menunggu Pembayaran', color: 'var(--warn)' },
  paid:       { emoji: '💚', label: 'Pembayaran Berhasil',  color: 'var(--success)' },
  processing: { emoji: '🔄', label: 'Sedang Diproses',      color: 'var(--accent)' },
  completed:  { emoji: '✅', label: 'Pesanan Selesai',       color: 'var(--success)' },
  cancelled:  { emoji: '❌', label: 'Dibatalkan',            color: 'var(--danger)' },
};

const cancelReasonMap = {
  expired:         '⏰ Tidak dibayar dalam 10 menit',
  user_cancelled:  '🙍 Dibatalkan oleh pembeli',
  admin_cancelled: '👤 Dibatalkan oleh admin',
};

export default function OrderStatusPage() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchOrder = useCallback(async () => {
    try {
      const res = await getOrder(orderId);
      setOrder(res.data.data);
    } catch(e) { console.error(e); }
    setLoading(false);
  }, [orderId]);

  useEffect(() => {
    fetchOrder();
    const iv = setInterval(fetchOrder, 10000);
    return () => clearInterval(iv);
  }, [fetchOrder]);

  if (loading) return <div className="loading"><div className="spinner"></div>Memuat pesanan...</div>;
  if (!order)  return <div className="empty-state page-enter"><span className="empty-icon">❌</span><p>Pesanan tidak ditemukan</p></div>;

  const st = statusMap[order.status] || statusMap.pending;

  return (
    <div style={{ maxWidth: 560, margin: '0 auto' }} className="page-enter">
      <div className="page-title">Status Pesanan</div>

      {/* Status hero */}
      <div className="status-hero">
        <span className="status-icon">{st.emoji}</span>
        <div className="status-label" style={{ color: st.color }}>{st.label}</div>
        {order.cancelReason && (
          <div style={{ fontSize: '0.82rem', color: 'var(--text2)', margin: '6px 0 10px' }}>
            {cancelReasonMap[order.cancelReason] || order.cancelReason}
          </div>
        )}
        <div className="status-oid">{order.orderId}</div>
      </div>

      {/* Info pemesan */}
      <div className="section-box">
        <div className="sec-title">// info pemesan</div>
        <div className="sum-row"><span>Nama</span><span style={{ fontWeight: 700 }}>{order.customer.name}</span></div>
        <div className="sum-row"><span>No. HP</span><span style={{ fontFamily: 'var(--mono)' }}>{order.customer.phone}</span></div>
        {order.customer.note && <div className="sum-row"><span>Catatan</span><span>{order.customer.note}</span></div>}
      </div>

      {/* Item pesanan */}
      <div className="section-box">
        <div className="sec-title">// item pesanan</div>
        {order.items.map((item, i) => (
          <div key={i} className="sum-row">
            <span style={{ fontSize: '0.85rem' }}>{item.name} ×{item.quantity}</span>
            <span style={{ fontFamily: 'var(--mono)', fontSize: '0.85rem' }}>{formatRupiah(item.subtotal)}</span>
          </div>
        ))}
        {order.payment.fee > 0 && (
          <div className="sum-row" style={{ fontSize: '0.83rem' }}>
            <span>Biaya layanan</span>
            <span style={{ fontFamily: 'var(--mono)' }}>{formatRupiah(order.payment.fee)}</span>
          </div>
        )}
        <div className="sum-row">
          <span>Total Dibayar</span>
          <span>{formatRupiah(order.payment.totalPayment || order.totalAmount)}</span>
        </div>
      </div>

      {/* Timeline */}
      <div className="section-box">
        <div className="sec-title">// riwayat</div>
        <div className="steps">
          <div className="step">
            <div className="step-num">✓</div>
            <div className="step-text">Pesanan dibuat: {new Date(order.createdAt).toLocaleString('id-ID')}</div>
          </div>
          {order.payment.paidAt && (
            <div className="step">
              <div className="step-num" style={{ background: 'var(--sdim)', borderColor: 'rgba(34,211,160,0.3)', color: 'var(--success)' }}>✓</div>
              <div className="step-text">Pembayaran diterima: {new Date(order.payment.paidAt).toLocaleString('id-ID')}</div>
            </div>
          )}
          {order.cancelledAt && (
            <div className="step">
              <div className="step-num" style={{ background: 'var(--ddim)', borderColor: 'rgba(244,63,94,0.3)', color: 'var(--danger)' }}>✕</div>
              <div className="step-text">Dibatalkan: {new Date(order.cancelledAt).toLocaleString('id-ID')}</div>
            </div>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', gap: 10 }}>
        {order.status === 'pending' && (
          <Link to={`/payment/${order.orderId}`} className="btn btn-primary" style={{ flex: 1 }}>
            ⚡ Lanjut Bayar
          </Link>
        )}
        <Link to="/" className="btn btn-secondary" style={{ flex: 1 }}>
          Belanja Lagi
        </Link>
      </div>
    </div>
  );
}
